import { render } from "./special.vue?vue&type=template&id=2479c6ea&scoped=true"
import script from "./special.vue?vue&type=script&lang=js"
export * from "./special.vue?vue&type=script&lang=js"

import "./special.vue?vue&type=style&index=0&id=2479c6ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2479c6ea"]])

export default __exports__